<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">Parking Site</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการข้อมูลสาขา / ลานจอดรถ (สร้างและแก้ไขเท่านั้น)</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <button (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="openCreate()"
        class="px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">add</span> เพิ่ม Site
      </button>
    </div>
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">local_parking</span>รายการ Parking Site
      </h3>
      <div class="relative w-full lg:max-w-md">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหาชื่อ, Key, Tax ID, Site EV, Site Parking..."
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">ID</th>
            <th class="p-4 w-[72px]">Logo</th>
            <th class="p-4">ชื่อ / Key</th>
            <th class="p-4">Tax ID</th>
            <th class="p-4">พิกัด</th>
            <th class="p-4 text-center">Online</th>
            <th class="p-4">เวลา</th>
            <th class="p-4">Site EV / Parking</th>
            <th class="p-4 text-center">Flags</th>
            <th class="p-4">แก้ไขล่าสุด</th>
            <th class="p-4 text-center w-[110px]">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let s of sites(); trackBy: trackById" class="hover:bg-slate-50/60 dark:hover:bg-slate-700/40 transition-all">
            <td class="p-4 font-mono font-bold text-slate-400">{{ s.id }}</td>
            <td class="p-4">
              <div class="w-11 h-11 rounded-xl border border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-900 overflow-hidden flex items-center justify-center">
                <img *ngIf="logoSrc(s) as src" [src]="src" [alt]="s.name || 'logo'" class="w-full h-full object-contain" />
                <span *ngIf="!s.logoBase64" class="material-icons text-slate-300 text-[20px]">image</span>
              </div>
            </td>
            <td class="p-4">
              <div class="font-bold text-slate-700 dark:text-slate-200">{{ s.name || '—' }}</div>
              <div class="text-[11px] font-mono text-slate-400">{{ s.key || '—' }}</div>
            </td>
            <td class="p-4 font-mono text-xs text-slate-500">{{ s.taxId || '—' }}</td>
            <td class="p-4 text-xs font-mono text-slate-500">
              <span *ngIf="s.latitude != null && s.longitude != null">{{ s.latitude }}, {{ s.longitude }}</span>
              <span *ngIf="s.latitude == null || s.longitude == null">—</span>
            </td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-xs font-bold"
                [ngClass]="s.isOnline
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400'">
                {{ s.isOnline ? 'Online' : 'Offline' }}
              </span>
            </td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">{{ s.openTime || '—' }} - {{ s.closeTime || '—' }}</td>
            <td class="p-4 text-xs">
              <div class="text-slate-600 dark:text-slate-300" [title]="s.siteEv">EV: {{ s.siteEv || '—' }}</div>
              <div class="text-slate-400 mt-0.5" [title]="s.siteParking">PK: {{ s.siteParking || '—' }}</div>
            </td>
            <td class="p-4">
              <div class="flex flex-wrap justify-center gap-1">
                <span *ngIf="s.parking" class="px-2 py-0.5 rounded-lg bg-sky-50 dark:bg-sky-900/20 text-sky-600 text-[10px] font-bold">Parking</span>
                <span *ngIf="s.ev" class="px-2 py-0.5 rounded-lg bg-violet-50 dark:bg-violet-900/20 text-violet-600 text-[10px] font-bold">EV</span>
                <span *ngIf="s.monthly" class="px-2 py-0.5 rounded-lg bg-amber-50 dark:bg-amber-900/20 text-amber-600 text-[10px] font-bold">Monthly</span>
                <span *ngIf="s.taiwanSite" class="px-2 py-0.5 rounded-lg bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 text-[10px] font-bold">Taiwan</span>
                <span *ngIf="!s.parking && !s.ev && !s.monthly && !s.taiwanSite" class="text-slate-400 text-xs">—</span>
              </div>
            </td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">{{ s.writeDate | date:'dd/MM/yyyy HH:mm' }}</td>
            <td class="p-4 text-center">
              <div class="inline-flex items-center gap-1">
                <button *ngIf="s.latitude != null && s.longitude != null" (click)="openGoogleMaps(s)" title="Google Maps"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-sky-400 hover:text-sky-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">map</span>
                </button>
                <button *ngIf="canUpdate" (click)="openEdit(s)" title="แก้ไข"
                  class="w-9 h-9 rounded-lg inline-flex items-center justify-center border border-slate-100 dark:border-slate-700 text-slate-400 hover:border-amber-400 hover:text-amber-500 transition-all cursor-pointer">
                  <span class="material-icons text-base">edit</span>
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && sites().length === 0">
            <td colspan="11" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2">search_off</span>
              <p class="font-bold">ไม่พบข้อมูล Parking Site</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-site *ngIf="isModalOpen()"
  [itemId]="selectedId()"
  (close)="closeModal()"
  (saveSuccess)="onSaveSuccess()">
</app-modal-parking-site>
